"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const round = (value, step = 1) => {
  const inv = 1 / step
  return Math.round(value * inv) / inv
}; exports.round = round
